<template>
  <div
    v-if="results && results.percentage > -1"
    rounded
    elevation="0"
    :class="getChipColor(results.percentage)"
    class="px-4 py-2 rounded-pill text-right font-weight-bold"
    @click="$emit('toggleBreakout')"
  >
    <div>
      {{ results.percentage | percentage }}
    </div>
  </div>
  <div v-else-if="results && results.percentage === null" class="text-center">
    --
  </div>
  <div v-else class="text-center">
    --
  </div>
</template>

<script>
import numeral from "numeral";
import { agreeColors } from "./Constants";
export default {
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    }
  },
  props: {
    results: Object
  },
  methods: {
    getChipColor(val) {
      let result = "";
      if (agreeColors) {
        for (let i = 0; i < agreeColors.length; i++) {
          if (val >= agreeColors[i].floor) {
            result = agreeColors[i].classes;
            break;
          }
        }
      }

      return result;
    }
  }
};
</script>
